var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p"},[_c('img',{attrs:{"src":require("@/views/pt/images/empty-study.png"),"alt":""}}),_c('p',[_vm._v("检测到您当前正在使用手机访问应用， 可能有部分功能无法支持。")]),_c('button',{staticClass:"p-button",on:{"click":_vm.jumpLink}},[_vm._v("继续访问")])])
}
var staticRenderFns = []

export { render, staticRenderFns }